<template>
  <UiTooltip v-model="isOpen" :open-on-hover="false" :open-on-click="true">
    <template #activator="slotProps">
      <UiButton
        v-bind="slotProps.props"
        :height="height"
        :width="width"
        :color="bgColor"
        rounded="md"
        icon="$copy"
        size="x-small"
        data-html2canvas-ignore
        class="clipboard"
        @click="copyToClipboard"
      >
      </UiButton>
    </template>
    Copied <UiIcon icon="$check" color="icon-accent" size="18" class="mt-n1" />
  </UiTooltip>
</template>
<script setup lang="ts">
import { UiIcon, UiButton } from '~/ui';
import UiTooltip from '../UiTooltip/UiTooltip.vue';

import { ref, computed } from 'vue';

export interface Props {
  copy: string;
  color?: string;
  bgColor?: string;
  width?: number | string;
  height?: number | string;
}
const props = withDefaults(defineProps<Props>(), {
  color: 'text-secondary',
  bgColor: 'transparent',
  width: '24',
  height: '24',
});

const isOpen = ref(false);
const tooltipDelay = 2000;

const closeTooltip = (): void => {
  setTimeout(() => {
    isOpen.value = !isOpen.value;
  }, tooltipDelay);
};

const copyToClipboard = (): void => {
  navigator.clipboard.writeText(props.copy.trim());
  closeTooltip();
};

const textColor = computed(() => {
  if (props.color === undefined || props.color === 'inherit') return 'inherit';
  if (props.color === 'currentColor') return 'currentColor';

  return `rgb(var(--v-theme-${props.color}))`;
});

defineExpose({
  isOpen,
});
</script>

<style lang="scss" scoped>
.clipboard {
  position: relative;
  top: -2px;
  color: v-bind(textColor);

  :deep(.v-icon) {
    color: v-bind(textColor);
  }
}
</style>
